import React, { Component } from 'react'

import ReactMarkdown from "react-markdown"


import {Link} from 'gatsby'
import BackgroundImage from 'gatsby-background-image'



class ProjectGrid extends Component {
  constructor(props) {
    super(props)



    this.layoutContents = React.createRef()

  }



  returnImage(image){

if(image === null || image === undefined ){
return ([
`backgroundColor:white;`
].reverse()
)
}else{
return ([
image.childImageSharp.fluid,
  `linear-gradient(60deg, rgba(0,0,0,0.7) 31%, rgba(0,0,0,0.3169642857142857) 77%)`
].reverse()
)
}
}

  render() {





    return (

      <li className="slice__item list__item row__item row__item--span-1">

          <div className="item itemEnlarge item--has-image item_title_middle">
    <BackgroundImage Tag="div" className="item__container" fluid={this.returnImage(this.props.data.image)}>

                  <div className="item__media">

                  </div>
                  <div className="item__content">
                      <div className="item__header">
                          <h3 className="item__title" style={{color:this.props.data.TileTextColor}}>
                              <a className="item__link" href="#">
                                  {this.props.data.title}
                              </a>
                          </h3>
                      </div>
                      <div className="item__teaser">

                      </div>
                  </div>
                  <Link className="block-link-overlay"
                    to={`/projects/${this.props.data.slug}`}
                  />
                            </BackgroundImage>
              </div>

      </li>


    )


}
}

export default ProjectGrid;
